import styled from "styled-components";
// import { ReactComponent as LoadingIcon } from '../../asset/loading.svg';
const LoadingURL = `https://kanimg.niu.niuxyx.com/niuxwebsite/11/pay/img/loading.gif`;




export const Mask = styled.div<{
    hidden?: boolean;
}>`

`;
export const Placeholder = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const Spin = styled("div")`
  font-size: 24px;
  width: 40px;
  height: 40px;
  background-image: url("${LoadingURL}");
  //color: #000;
  //color: #269bff;
  //animation: loadingCircle 1s infinite linear;
`;
export const SpinText = styled.span`
  //position: absolute;
  //top: 50%;
  width: 100%;
  text-align: center;
  padding-top: 5px;
  text-shadow: 0 1px 2px #fff;
  color: #fc8321;
`;
export const Button = styled.div``;
